import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
 ChangeDetectorRef,
 Component,
 DestroyRef,
 Input,
 OnChanges,
 OnInit,
 SimpleChanges,
 ViewChild,
 afterNextRender,
 computed,
 inject,
 signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ModalHotelGallery } from '@core/models/domains/hotel';
import { LoadingService } from '@shared/services/loading.service';
import { ModalService } from '@shared/services/modal.service';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';
import { SwiperComponent } from 'swiper/angular';
import { GalleryModalComponent } from '../../components/gallery-modal/gallery-modal.component';
import { PdpSkeletonComponent } from '../../components/pdp-skeleton/pdp-skeleton.component';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-pdp-gallery-wrapper',
 standalone: true,
 imports: [CommonModule, SharedModule, FormsModule, NgOptimizedImage, PdpSkeletonComponent],
 templateUrl: './pdp-gallery-wrapper.component.html',
 styleUrls: ['./pdp-gallery-wrapper.component.scss'],
})
export class PdpGalleryWrapperComponent implements OnInit {
 @Input() hotelId?: number;
 @Input() ecolodgeType?: number;
 @Input() dataSource?: ModalHotelGallery;
 resetSwiper = signal(true);
 configSwiperGalleryWrapper: any;
 dialog = inject(MatDialog);
 realIndexSlider = 1;
 swiperService = inject(SwiperService);
 modalService = inject(ModalService);
 loadingService = inject(LoadingService);
 cdr = inject(ChangeDetectorRef);
 @ViewChild('swiperGalleryWrapper', { static: false })
 swiper?: SwiperComponent;
 cdnUrl = cdnUrl;
 destroyRef = inject(DestroyRef);

 ngOnInit(): void {
  let config = {
   slide: 'auto',
   pagination: {
    enabled: true,
    clickable: true,
   },
   //   navigation: true,
  };

  this.configSwiperGalleryWrapper = this.swiperService.SwiperConfig(config);
 }
 showModalGallery() {
  // this.loadingService.isInterceptorActive.set(true);

  const dialogRef = this.dialog.open(GalleryModalComponent, {
   panelClass: [
    'gallery-modal',
    'w-screen',
    'lg:w-[60%]',
    'h-screen',
    '!max-w-full',
    'lg:h-[75vh]',
    'lg:min-h-[680px]',
    'custom-modal',
   ],
   data: {
    hid: this.hotelId,
    Name: this.dataSource?.HotelName,
    allPhotos: true,
    accommodationType: this.ecolodgeType,
    shabWebsitePhotos: this.ecolodgeType == 1 ? [] : this.dataSource?.Pictures,
   },
   autoFocus: false,
  });

  dialogRef
   .afterClosed()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((result) => {
    this.modalService.isAnyModalOpen.set(false);
   });

  dialogRef
   .afterOpened()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe(() => {
    this.modalService.isAnyModalOpen.set(true);
   });
 }

 openSingleImage(imageIndex: number) {
  const dialogRef = this.dialog.open(GalleryModalComponent, {
   panelClass: [
    'gallery-modal',
    'w-screen',
    'lg:w-[60%]',
    'h-screen',
    '!max-w-full',
    'lg:h-[75vh]',
    'lg:min-h-[680px]',
    'custom-modal',
   ],
   data: {
    hid: this.hotelId,
    Name: this.dataSource?.HotelName,
    allPhotos: false,
    imageIndex: imageIndex,
    accommodationType: this.ecolodgeType,
    shabWebsitePhotos: this.ecolodgeType == 1 ? [] : this.dataSource?.Pictures,
   },
   autoFocus: false,
  });

  dialogRef.afterClosed().subscribe((result) => {
   this.modalService.isAnyModalOpen.set(false);
  });

  dialogRef.afterOpened().subscribe(() => {
   this.modalService.isAnyModalOpen.set(true);
  });
 }

 onSlideChange(ev: any) {
  this.realIndexSlider = ev[0].realIndex + 1;
  this.cdr.detectChanges();
 }
}
